export const ABOUT_HASH_KEYS = new Array(16).fill(null).map((item, index) => index + 1);
export const GAME_INFO_KEYS = new Array(25).fill(null).map((item, index) => index + 1);
